//src/components/Games.vue
<template>
    <section>
        <div class="container">
            <b-table
                v-if="!loading"
                class="table is-striped is-hoverable"
                :data="games"
                ref="table"
                :paginated="isPaginated"
                :per-page="perPage"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                default-sort="name"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page">

                <b-table-column field="cover" label="Covers" v-slot="props">
                    <div class="border-dark" style="height: 140px; vertical-align: middle; border-width: 1px; border-color: black;">
                        <b-image :src="'https://res.cloudinary.com/dowtef4tq/image/upload/c_thumb,w_80,e_sharpen/' + props.row.cover"></b-image>
                    </div>
                </b-table-column>
                <b-table-column field="name" label="Title" sortable v-slot="props">
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column field="year" label="Year" sortable v-slot="props">
                    {{ props.row.year }}
                </b-table-column>
                <b-table-column field="platform" label="Platform" sortable v-slot="props">
                    {{ props.row.platform }}
                </b-table-column>
                <b-table-column field="developer" label="Developer" sortable v-slot="props">
                    {{ props.row.developer }}
                </b-table-column>
                <b-table-column field="region" label="Region" sortable v-slot="props">
                    {{ props.row.region }}
                </b-table-column>
                <b-table-column field="manual" label="Manual" sortable v-slot="props">
                    {{ props.row.manual }}
                </b-table-column>
                <b-table-column field="box" label="Box" sortable v-slot="props">
                    {{ props.row.box }}
                </b-table-column>
                <b-table-column field="finished" label="Finished" sortable v-slot="props">
                    {{ props.row.finished }}
                </b-table-column>
            </b-table>
        </div>
    </section>
</template>

<script>
//import AddGame from './AddGame.vue';
import axios from "axios";

export default {
    name: 'games',
    components: {
        //AddGame,
    },
    data() {
        return {
            games: [],
            fields: [],
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: 'bottom',
            defaultSortDirection: 'asc',
            sortIcon: 'arrow-up',
            sortIconSize: 'is-small',
            currentPage: 1,
            perPage: 7
        };
    },
    computed: {
      rows() {
        return this.games.length
      }
    },
    mounted() {
        var jwtAccessToken = ""
        if(this.$store.state.token != "authToken") {
            jwtAccessToken = this.$store.state.token;
        } else if(localStorage.getItem('accessToken')) {
            jwtAccessToken = localStorage.getItem('accessToken');
        } else {
            console.log("No token set");
        }
        const options = {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + jwtAccessToken
            },
            timeout: 1000
        }

        const url = 'https://gamedb-backend.herokuapp.com/games';
        axios
        .get(url, options)
        .then(response => {
            this.games = response.data;
            this.fields = [
                { field: 'cover', label: 'Cover' },
                { field: 'name', label: 'Title', sortable: true },
                { field: 'year', label: 'Year', sortable: true },
                { field: 'platform', label: 'Platform', sortable: true },
                { field: 'developer', label: 'Developer', sortable: true },
                { field: 'region', label: 'Region', sortable: true },
                { field: 'manual', label: 'Manual', sortable: true },
                { field: 'box', label: 'Box', sortable: true },
                { field: 'finished', label: 'Finished', sortable: true }
            ];
        })
        .catch(err => {
            console.log("axios error:" + err);
        });
    }
};
</script>
